module.exports = __webpack_public_path__ + "assets/img/report-animation-img.34d41a79.svg";